import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { GetMember, GetMemberResponse } from '@edtech-ui/core/models/members/student';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { MemberManagementService } from '@edtech-ui/core/services/member-management-services/member-management.service';
import { SharedModule } from '@edtech-ui/shared/shared.module';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subscription } from 'rxjs';

@Component({
	selector: 'app-student-classroom-members',
	standalone: true,
	imports: [SharedModule, MatMenuModule, MatIconModule, NgFor],
	templateUrl: './student-classroom-members.component.html',
	styleUrl: './student-classroom-members.component.scss'
})
export class StudentClassroomMembersComponent implements OnInit, OnDestroy {
	classroomId: number | null = null;
	_teachers: GetMember[] = [];
	_students: GetMember[] = [];
	loggedInUserId: string = localStorage.getItem('user_id') || '';
	isLoadingMembers: boolean = false;
	subscription = new Subscription();

	constructor(
		private _memberService: MemberManagementService,
		private _classroomService: ClassroomManagementService,
		private _toastr: ToastrService,
		private route: ActivatedRoute,
		private router: Router
	) { }

	get isLoading(): boolean {
		return this.isLoadingMembers;
	}

	ngOnInit(): void {
		const id = this.route.parent?.snapshot.paramMap.get('id');
		if (id) {
			this.classroomId = Number(id);
			this.fetchMembers();
		} else {
			this._toastr.error('Classroom ID not found in the URL.');
			this.router.navigate(['/student-dashboard/classrooms']);
		}
	}

	fetchMembers() {
		if (!this.classroomId) {
			this._toastr.error('Classroom ID is missing.');
			this.router.navigate(['/student-dashboard/classrooms']);
			return;
		}

		this.isLoadingMembers = true;
		this.subscription.add(
			this._memberService.getMembers(this.classroomId).subscribe({
				next: (response: GetMemberResponse) => {
					if (response.Success) {
						this._teachers = response.Data.teachers || [];
						this._students = response.Data.students || [];
						this._teachers.sort((a, b) => {
							if (a.user_id === this.loggedInUserId) return -1;
							if (b.user_id === this.loggedInUserId) return 1;
							return 0;
						});
						this.isLoadingMembers = false;
					} else {
						this._toastr.error(response.Message || 'Failed to fetch members.');
						this.isLoadingMembers = false;
					}
				},
				error: () => {
					this._toastr.error('Failed to fetch members due to a server error. Check the console for details.');
					this.isLoadingMembers = false;
				}
			})
		);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}